import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SearchBar from 'components/SearchBar/SearchBar.component';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary.component';
import Sidebar from 'components/Sidebar/Sidebar.component';
import TopBar from 'components/TopBar/TopBar.component';
import Notifications from 'components/Notifications/Notifications.component'
import Toggle from 'components/Toggle/Toggle.component';
// import UserBack from 'components/UserBack/UserBack.component';
import BreadcrumbsContextProvider from 'context/breadcrumbsContextWrapper';
import Footer from 'components/Footer/Footer.component';
import {mainWrapper, browserArea, toggleSpacer } from './styles.module.scss';


const ScrollUp = React.lazy(() => import('./ScrollUp'))

function Layout({ 
  children, 
  pathname, 
  sourcePath = '', 
  searchParams = '', 
  location = {}, 
  isSearch = false,
  pageData = {},
  title,
  q = null
 }) {

  const [toggleSearchBar, setToggleSearchBar] = useState(false)

    const handleKeyPress = useCallback((event) => {
      if((event.ctrlKey || event.metaKey) && event.keyCode === 75){
        event.preventDefault();
        if(toggleSearchBar){
          setToggleSearchBar(false)
        } else {
          setToggleSearchBar(true)
        }
      }
    }, [toggleSearchBar])
  
    useEffect(() => {
      document.addEventListener('keydown', handleKeyPress);
      return () => {
        document.removeEventListener('keydown', handleKeyPress)
      }
    }, [handleKeyPress])

  return (
      <div className={`${mainWrapper} main-layout`}>

        <BreadcrumbsContextProvider>
          <ErrorBoundary message="Sidebar">
            <Sidebar path={pathname} sourcePath={sourcePath} searchParams={searchParams} isSearch={isSearch} pageData={pageData} />
          </ErrorBoundary>

            <div className={`${browserArea} ${(pathname === '/search/' || pathname === '/how-to') ? 'announcementSibling' : 'page-wave announcementSibling' }`}>
              <TopBar toggleSearchBar={toggleSearchBar} path={pathname} title={title}>
                  <ErrorBoundary message="SearchBar">
                      <SearchBar 
                          path={pathname} 
                          location={location}
                          toggleSearchBar={toggleSearchBar}
                          setToggleSearchBar={setToggleSearchBar} 
                      />
                  </ErrorBoundary>
                  <ErrorBoundary message="Notifications">
                    <Notifications />
                  </ErrorBoundary>
                  { typeof window === 'undefined' ? <div className={toggleSpacer}/> : <Toggle /> }
              </TopBar>
              <div className="mainContentArea">
                <div className="articleContent" id="main-content">{children}</div>
              </div>
              <Footer />


              {/* <UserBack /> */}

              {
                q !== null ? null : <React.Suspense fallback={<span className="scroll-up"/>}>
                            <span className="scroll-up"><ScrollUp /></span>
                        </React.Suspense>
              }
        
              
            </div>
        </BreadcrumbsContextProvider>
      </div>
  );
}


Layout.propTypes = {
  children: PropTypes.oneOfType(
   [PropTypes.element, PropTypes.arrayOf(PropTypes.element), PropTypes.bool, PropTypes.object],
  ).isRequired,
  location: PropTypes.object,
  pathname: PropTypes.string.isRequired,
  sourcePath: PropTypes.string,
  searchParams: PropTypes.string,
  isSearch: PropTypes.bool,
  pageData: PropTypes.object,
  q: PropTypes.string,
  title: PropTypes.string.isRequired
};

export default Layout;
